import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import { first } from 'rxjs/internal/operators/first';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Store } from '@ngrx/store';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { ImagilityBaseResponse } from 'src/app/data/models/response.model';
import { getSubTaskDetails } from '../../store/selectors/sub-task-details.selectors';
import { SubTaskDetails } from 'src/app/data/models/subTaskDetails.model';
import { NotifyCodeNoAction } from '../../../../data/constants/notification-type-code';

@Component({
  selector: 'app-send-notification',
  templateUrl: './send-notification.component.html',
  styleUrls: ['./send-notification.component.scss']
})
export class SendNotificationComponent implements OnInit {

  sendNotificationForm: NgForm;
  stepDetails: TaskStep;
  disabledControls: boolean;
  receiversList: { name: string, type: string, employeeId: number, companyId: number }[];
  notification: {
    selectedReceiverType: string,
    message: string,
    companyId?: number,
    employeeId?: number
  };
  userType: string;
  observableSubscription$ = new Subject();
  subTaskDetails: SubTaskDetails;

  constructor(
    private guard: DirtyFormGuard,
    private dynamicDialogRef: DynamicDialogRef,
    private petitioner: PetitionerService,
    private store: Store<any>,
    private toastr: ToastrService) {
    this.disabledControls = false;
    this.receiversList = [];
    this.notification = {
      selectedReceiverType: null,
      message: '',
    }
    this.userType = sessionStorage.getItem('userTypeRole');
  }

  ngOnInit(): void {
    // Get Specific Task Details  
    this.store.select(getSubTaskDetails).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SubTaskDetails) => {
      if (data) {
        this.subTaskDetails = data;
        if (this.userType !== 'Beneficiary' && this.subTaskDetails.beneficiaryDetails) {
          // Adding Beneficiary to list
          this.receiversList.push({ name: `${this.subTaskDetails.beneficiaryDetails.firstName} ${this.subTaskDetails.beneficiaryDetails.lastName}`, type: 'BENEFICIARY', employeeId: this.subTaskDetails.beneficiaryDetails.id, companyId: this.subTaskDetails.companyId });
        }
        if (this.userType !== 'Petitioner' && this.subTaskDetails.preparePetitionerName) {
          // Adding Petitioner to list
          this.receiversList.push({ name: this.subTaskDetails.preparePetitionerName, type: 'PETITIONER', employeeId: this.subTaskDetails.immSpecialistId, companyId: this.subTaskDetails.companyId });
        }
        if (this.userType !== 'Attorney' && this.subTaskDetails.preparerAttorneyName) {
          // Adding Attorney to list
          this.receiversList.push({ name: this.subTaskDetails.preparerAttorneyName, type: 'ATTORNEY', companyId: this.subTaskDetails.attorneyId, employeeId: this.subTaskDetails.preparerAttorneyId });
          console.log(this.receiversList);
        }
      }
    });
  }

  postSendNotification() {
    console.log(this.notification);
    const payload = {
      beneficiaryId: this.notification.selectedReceiverType['type'] === 'BENEFICIARY' ? this.notification.selectedReceiverType['employeeId'] : null,
      channelType: 'APP',
      companyId: this.notification.selectedReceiverType['companyId'],
      data: `{"superTaskId": ${this.subTaskDetails.superTaskId}}`,
      employeeId:  (this.notification.selectedReceiverType['type'] === 'PETITIONER' || this.notification.selectedReceiverType['type'] === 'ATTORNEY') ? this.notification.selectedReceiverType['employeeId'] : null,
      id: null,
      notificationType: NotifyCodeNoAction.TASK_AUDIT,
      notifyAllBeneficiaries: false,
      notifyAllEmployees: false,
      priority: '',
      text: this.notification.message,
      title: 'I-140 Activity'
    };
    this.petitioner.postNotification(payload).subscribe((response: ImagilityBaseResponse) => {
      if (response.status === 200) {
        this.toastr.success(response.message, 'Success');
      }
    });
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  handleCancel(){
    this.dynamicDialogRef.close();
  }

  handleClose() {
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.dynamicDialogRef.close();
      }
      else {
        return false;
      }
    });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
